import { render, staticRenderFns } from "./presentationProductMagytrack.vue?vue&type=template&id=264c9f5e&"
import script from "./presentationProductMagytrack.vue?vue&type=script&lang=js&"
export * from "./presentationProductMagytrack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports